import { baseRequestHandler } from '../../api/http-client/request-handler'


const CategoriesService = {
  getCategories() {
    return baseRequestHandler.get('theme', {
      params: {
        platform: 'volunteering',
      },
    })
      .then(({ result }) => result)
  },
}

export default CategoriesService
